import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-documentos-certi',
  templateUrl: './documentos-certi.component.html',
  styleUrls: ['./documentos-certi.component.css']
})
export class DocumentosCertiComponent implements OnInit,AfterContentInit {
  dimensionW:number
  pdfSource:string
  folio:string
  _color:string = `white`
  constructor(private route: ActivatedRoute) { 
    this.pdfSource = ''
    this.folio = ''
    this.dimensionW = screen.width
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next:(params) =>{
         this.folio = params.get('folio') as string
        // console.log(params.get('folio'))
        this.pdfSource = `/assets/${this.folio}_2.pdf`
      },
    })
  }

  ngAfterContentInit(): void {
    // setTimeout(() => {
    //   let canvas = document.getElementsByTagName('canvas')[0]
    //   console.log(canvas)
    //   canvas.style.setProperty('font-size','28px !important')
    //   let ctrx = canvas.getContext('2d')
    //   if(ctrx != undefined){
    //     console.log('entra')
        
    //   }
    // console.log()
    // }, 2000);
  }
}
